import { ReactElement } from "react"

interface IConditional {
    condition: boolean
    children: ReactElement
}

/**
 * Returns children if condition is true, otherwise returns empty fragment
 */
const DisplayIf = ({
    condition,
    children,
}: IConditional): ReactElement | null => (condition ? children : null)

export default DisplayIf
